"use client";

import { ColumnDef } from "@tanstack/react-table";
import { MoreHorizontal, ArrowUpDown } from "lucide-react";
import React from "react";

import { Button } from "../ui/button.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu.tsx";
import profile from "../../img/profile.png";

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
// export type User = {
//   id: string;
//   amount: number;
//   status: "pending" | "processing" | "success" | "failed";
//   email: string;
// };

export const columns: ColumnDef<any>[] = [
  // {
  //   accessorKey: "username",
  //   header: "Name",
  // },
  {
    accessorKey: "username",
    header: ({ column }) => {
      return (
        <Button
          className="tw-bg-ghost tw-text-left tw-text-xl"
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Name
          <ArrowUpDown className="tw-ml-1 tw-h-4 tw-w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      // const amount = parseFloat(row.getValue("amount"));
      // const formatted = new Intl.NumberFormat("en-US", {
      //   style: "currency",
      //   currency: "USD",
      // }).format(amount);

      const obj = row.original;

      return (
        <ul
          className="flex-row"
          style={{
            alignItems: "center",
            gap: 0,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
          }}
        >
          <li>
            {obj.photoUrl ? (
              <img
                style={{
                  width: 45,
                  height: 45,
                  marginRight: 20,
                  borderRadius: 90,
                  objectFit: "cover",
                }}
                src={obj.photoUrl}
                alt=""
              ></img>
            ) : (
              <img
                style={{
                  width: 45,
                  height: 45,
                  marginRight: 20,
                }}
                src={profile}
                alt=""
              ></img>
            )}
          </li>
          <li>
            <h1 style={{ paddingBottom: 0 }}>
              <a
                style={{
                  cursor: "pointer",
                  // marg inBottom: "20px",
                  fontSize: 16,
                  color: "#000",
                }}
              >
                {row.getValue("username") + "\n"}
              </a>
            </h1>
            {/* <a
              style={{
                // marginBottom: "20px",
                color: "#4b5467",
              }}
            >
              {obj.mail ? obj.mail + "\n" : "-" + "\n"}
            </a> */}
          </li>
        </ul>
      );

      // return (
      //   <div className="tw-text-left tw-font-bold">
      //     {row.getValue("username")}
      //   </div>
      // );
    },
  },
  {
    accessorKey: "mail",
    header: ({ column }) => {
      return (
        <Button
          className="tw-bg-ghost tw-text-left tw-text-xl"
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          E-Mail
          <ArrowUpDown className="tw-ml-1 tw-h-4 tw-w-4" />
        </Button>
      );
    },
    // header: () => <div className="tw-text-left tw-text-xl">E-Mail</div>,
    cell: ({ row }) => {
      return (
        <div className="tw-text-left tw-font-normal">
          {row.getValue("mail") ? row.getValue("mail") + "\n" : "-" + "\n"}
        </div>
      );
    },
  },
  {
    accessorKey: "status",
    header: () => <div className="tw-text-right tw-text-xl"> </div>,
    cell: ({ row }) => {

      return (
        <>
          {row.original?.request?.isNew ? (
            <div className="tw-text-right tw-font-normal">
              <Button variant="destructive" size="round">
                Neue Anfrage
              </Button>
            </div>
          ) : (
            <></>
          )}
        </>
      );
    },
  },
  // {
  //   id: "actions",
  //   cell: ({ row }) => {
  //     const payment = row.original;

  //     return (
  //       <DropdownMenu>
  //         <DropdownMenuTrigger asChild>
  //           <Button variant="ghost" className="tw-h-8 tw-w-8 tw-p-0">
  //             <span className="tw-sr-only">Open menu</span>
  //             <MoreHorizontal className="tw-h-4 tw-w-4" />
  //           </Button>
  //         </DropdownMenuTrigger>
  //         <DropdownMenuContent align="end">
  //           <DropdownMenuLabel>Actions</DropdownMenuLabel>
  //           <DropdownMenuItem
  //             onClick={() => navigator.clipboard.writeText(payment.id)}
  //           >
  //             Copy payment ID
  //           </DropdownMenuItem>
  //           <DropdownMenuSeparator />
  //           <DropdownMenuItem>View customer</DropdownMenuItem>
  //           <DropdownMenuItem>View payment details</DropdownMenuItem>
  //         </DropdownMenuContent>
  //       </DropdownMenu>
  //     );
  //   },
  // },
];
